<template>
  <div class="url-component-wrapper">
    <span
      v-if="params.data.url_tracking_method === 'exact'"
      class="kw kw-crosshair target_exact_icon"
      @mouseover="
        tooltip({
          text: $t('tracking-method', { type, ignoreSub }),
          event: $event,
        })
      "
    />
    <span
      v-else
      class="icon-wrapper"
      @mouseover="
        tooltip({
          text: $t('tracking-method', { type, ignoreSub }),
          event: $event,
        })
      "
    >
      <span class="kw kw-maximize-2" />
      <span class="kw kw-maximize-2" />
    </span>
    <div class="table-cell__url-link-blok table-cell__content_url">
      <a
        class="table-cell__url-link"
        :href="'//' + params.data.originalUrl"
        :data-important-tooltip="params.data.originalUrl"
        target="_blank"
        v-html="params.data.originalUrl"
      />
    </div>
  </div>
</template>

<script>
import ToolTipRenderMixin from '@/mixins/ToolTipRenderMixin';
import { capitalize } from '@/helpers';

export default {
  name: 'UrlRenderer',
  mixins: [ToolTipRenderMixin],
  components: {},
  computed: {
    ignoreSub() {
      return this.params.data.ignore_sub_domains ? 'Yes' : 'No';
    },
    type() {
      return capitalize(this.params.data.url_tracking_method);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.url-component-wrapper {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  gap: 5px;
  padding: 0 15px 0 3px;
  position: relative;

  .table-cell__url-not-found {
    color: kw-color(kw-grey, 1);
    font-size: 12px;
    font-weight: 700;
    position: absolute;
    left: 3px;
  }

  .table-cell__content_url {
    display: grid;
  }

  .table-cell__url-link {
    color: kw-color(kw-blue, 1);
    display: block;
    @import '~sass/cutting-name';
  }

  .target_exact_icon {
    color: kw-color(kw-grey, 1);
    font-size: 12px;
    font-weight: 700;
  }

  .icon-wrapper {
    position: relative;
    display: inline-block;
    width: 12px;
    min-width: 12px;
    height: 12px;
    font-size: 12px;
    .kw-maximize-2 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .kw-maximize-2:nth-child(2) {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }
}
</style>
